import { t } from "i18next";

import { ApiSuffixType } from "../../enums";
import {
  entityApiPathMappings,
  isEntityApiPathMapped,
  isEntityGlobal,
} from "../../mappers";
import { RydeUiUnit } from "../../models";
import { getCompanyId } from "../common.helpers";
import { Log } from "../log.helpers";

const getSchemeSuffix = (
  entity: RydeUiUnit,
  suffixType: ApiSuffixType,
): string => {
  const isGlobalEntity = isEntityGlobal(entity);
  const companyId = getCompanyId();

  if (!companyId) {
    const errorText = t("errors.invalidCompanyInAPIForEntity", {
      entity: entity,
    });
    Log.errorAndToast(errorText);
    return "";
  }

  switch (suffixType) {
    case ApiSuffixType.DynamicFormsScheme:
      return `/c/${companyId}/screenSchemas`;

    case ApiSuffixType.DropdownItems:
      if (isGlobalEntity) {
        return ""; // for now using current api, should be replaced with optimized
      } else {
        return `/c/${companyId}`;
      }

    case ApiSuffixType.DropdownItemsFiltered:
      if (isGlobalEntity) {
        return ""; // for now using current api, should be replaced with optimized
      } else {
        return `/c/${companyId}`;
      }

    default:
      if (isGlobalEntity) {
        return ""; // for now using current api, should be replaced with optimized
      } else {
        return `/c/${companyId}`;
      }
  }
};

export const getEntityPath = (
  entity: RydeUiUnit,
  suffixType: ApiSuffixType,
): string | undefined => {
  const isEntityMapped = isEntityApiPathMapped(entity);

  switch (suffixType) {
    case ApiSuffixType.DynamicFormsScheme:
      return entity;
    case ApiSuffixType.DropdownItems:
      return isEntityMapped
        ? `${entityApiPathMappings[entity]}/dropdown_items`
        : `${entity}/dropdown_items`;
    case ApiSuffixType.DropdownItemsFiltered:
      return isEntityMapped
        ? `${entityApiPathMappings[entity]}/dropdown_items_filtered`
        : `${entity}/dropdown_items`;
    case ApiSuffixType.ServerSearch:
      // dropItemsSource is set as plural form of entity and in such case will not be mapped
      //return entityToPathMappings[entity] || entity;
      return isEntityMapped
        ? `${entityApiPathMappings[entity]}/search`
        : `${entity}/search`;
    default:
      return isEntityMapped ? entityApiPathMappings[entity] : entity;
  }
};

export const apiUrlBase = (
  entity: RydeUiUnit,
  suffixType: ApiSuffixType = ApiSuffixType.NoSuffix,
  customSuffix?: string,
): string => {
  const schemeSuffixes = getSchemeSuffix(entity, suffixType);
  const entityPath = getEntityPath(entity, suffixType);
  const customSuffixResolved = customSuffix ? `/${customSuffix}` : "";

  if (entityPath) {
    return `/api/v1/core${schemeSuffixes}/${entityPath}${customSuffixResolved}`;
  }

  return "";
};
